import { createFileRoute } from '@tanstack/react-router';

import { CampaignCreatePage } from '@/features/campaign';

export const Route = createFileRoute('/workspace/$workspaceId/campaigns/create')({
  component: CampaignCreatePage,
});
